/**
 * Put an arbitrary list of elements in a container
 * and randomly show one every specified interval
 *
 * data-sw-text-spinner - ROOT
 * data-sw-text-spinner-duration - interval length in milliseconds
 * data-sw-text-spinner-item - item to enter rotation
 *
 */


var $             = require('js/sw-jquery/sw-jquery');
var ShapewaysView = require('./ShapewaysView');
var _             = require('underscore');


var TextSpinner = ShapewaysView.extend({

  swSelectors: {
    ROOT: '[data-sw-text-spinner]'
  },

  swAttrs: {
    duration: 'data-sw-text-spinner-duration',
    item:     'data-sw-text-spinner-item'
  },

  viewDefaults: {
    keepGoing: true
  },

  initialize: function () {

    this.state.set({
      time:     new Date().getTime(),
      duration: this.cachedElements.$duration.data('swTextSpinnerDuration')
    });

    window.requestAnimationFrame(_.bind(this.draw, this));
  },

  draw: function draw() {
    // We cancel the loop if the element leaves the DOM
    if (this.state.attributes.keepGoing) {
      window.requestAnimationFrame(_.bind(this.draw, this));
    }

    var time     = new Date().getTime();
    var lastTime = this.state.attributes.time;
    var duration = this.state.attributes.duration;

    if ((time - lastTime) > duration) {

      this.shuffle();

      var updates = {
        time: time
      };

      // prevent memory leaks by checking if el is in the DOM
      // this is as fast as it gets
      // @see http://jsperf.com/jquery-element-in-dom/60
      if (!$.contains(document.documentElement, this.$el[0])) {
        updates.keepGoing = false;
      }

      this.state.set(updates);
    }
  },

  shuffle: function shuffle() {
    this.hideAllChildren();
    this.showRandomChild();
  },

  hideAllChildren: function hideAllChildren() {

    this.cachedElements.$item.addClass('sw--is-hidden');

  },

  showRandomChild: function showRandomChild() {
    var index = parseInt(Math.random() * (this.cachedElements.$item.length), 10);
    $(this.cachedElements.$item[index]).removeClass('sw--is-hidden');
  }

});

module.exports = TextSpinner;
